import { render, staticRenderFns } from "./BaseLinkStyled.vue?vue&type=template&id=4d69e363&scoped=true&"
import script from "./BaseLinkStyled.vue?vue&type=script&lang=js&"
export * from "./BaseLinkStyled.vue?vue&type=script&lang=js&"
import style0 from "./BaseLinkStyled.vue?vue&type=style&index=0&id=4d69e363&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d69e363",
  null
  
)

export default component.exports